import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Typography,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CommonUtil from "../../Util/CommonUtils";
import { REACT_PRODUCT_MANAGEMENT } from "../../actions/EndPoints";
import {
  default as CustomTextfeild,
  default as CustomTextfield,
} from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  addProduct,
  updateProduct,
} from "../../slices/ProductSlice/ProductSlice";
import ProfileUpload from "../Employee/UploadImg";

function AddProduct(props) {
  const [profile, setProfile] = useState("");
  const [payload, setPayload] = useState({
    id: "",
    productName: "",
    productModel: "",
    description: "",
    monthlyPrice: 0.0,
    oneTimePrice: 0.0,
    productImage: "",
    productImageFile: null,
    productType: "HARDWARE",
  });
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const [productType, setProductType] = useState("hardWare");

  useEffect(() => {
    if (props.location.state?.id) {
      setPayload({
        id: props.location.state.id,
        productName: props.location.state.productName,
        productModel: props.location.state.productModel,
        description: props.location.state.description,
        monthlyPrice: props.location.state.monthlyPrice,
        oneTimePrice: props.location.state.oneTimePrice,
        productType: props.location.state.productType,
        stripeProductId: props.location.state.stripeProductId,
      });
      setProfile(props.location.state.productImagePresignedUrl);
      setProductType(
        props.location.state.productType === "HARDWARE"
          ? "hardWare"
          : "accessory"
      );
    }
  }, []);

  const handleCancel = () => {
    history.push({
      pathname: REACT_PRODUCT_MANAGEMENT,
    });
  };

  const handleSubmit = () => {
    if (CommonUtil.isEmptyString(profile)) {
      Toast("Image is mandatory", "error");
      return;
    }
    if (CommonUtil.isEmptyString(payload.productName)) {
      Toast(t("COMMON065"), "error");
      return;
    }
    if (
      productType === "hardWare" &&
      CommonUtil.isEmptyString(payload.monthlyPrice)
    ) {
      Toast(t("MONTHLY_PRICE_MANDATORY"), "error");
      return;
    }
    if (CommonUtil.isEmptyString(payload.oneTimePrice)) {
      Toast(t("ONE_TIME_PRICE_MANDATORY"), "error");
      return;
    }
    if (CommonUtil.isEmptyString(productType)) {
      Toast(t("PRODUCT_TYPE_MANDATORY"), "error");
      return;
    }
    const formData = new FormData();
    for (const key in payload) {
      if (payload[key] != null) {
        formData.append(key, payload[key]);
      }
    }
    if (payload.productImageFile !== null) {
      formData.append("productImageFile", payload.productImageFile);
    }
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }
    if (props.location.state?.id) {
      dispatch(updateProduct(formData))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4039") {
            Toast(res.message, "success");
            history.push({
              pathname: REACT_PRODUCT_MANAGEMENT,
            });
            return;
          }
        });
    } else {
      dispatch(addProduct(formData))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4026") {
            Toast(res.message, "success");
            history.push({
              pathname: REACT_PRODUCT_MANAGEMENT,
            });
            return;
          } else {
            Toast(res.message, "error");
            return;
          }
        });
    }
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
  };

  const handleProfilePicture = (file) => {
    if (file) {
      setPayload({
        ...payload,
        productImageFile: file.file,
      });
    }
    setProfile(file.base64);
  };

  const handleRadioChange = (event) => {
    if (event.target.value === "hardWare") {
      setProductType(event.target.value);
      setPayload({
        ...payload,
        productType: "HARDWARE",
      });
    } else {
      setProductType(event.target.value);
      setPayload({
        ...payload,
        productType: "ACCESSORY",
      });
    }
  };

  const handleChangeAmount = (e) => {
    const { name, value } = e.target;
    const decimalPattern = /^\d{1,5}(\.\d{0,2})?$/;
    if (value === "" || decimalPattern.test(value)) {
      setPayload((prevPayload) => ({
        ...prevPayload,
        [name]: value,
      }));
    }
  };

  const calculateInitialHeight = () => {
    return window.innerHeight - 150;
  };

  const [height, setHeight] = useState(calculateInitialHeight);
  const [initialWindowHeight, setInitialWindowHeight] = useState(
    window.innerHeight
  );

  useEffect(() => {
    const handleResize = () => {
      const percentageChange = (window.innerHeight / initialWindowHeight) * 100;

      setHeight(calculateInitialHeight);
      setInitialWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [initialWindowHeight]);

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", height: "85vh" }}>
        <HeaderToolbar
          title={props.location.state?.id ? "Edit Product" : "Add Product"}
          back_button={true}
        />
        <Paper
          style={{
            flex: 1,
            width: "100%",
            Height: "100%",
            backgroundColor: "#fff",
            marginTop: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: `${height}px`,
            overflowY: "auto",
            scrollbarWidth: "none",
          }}
        >
          <div
            style={{
              flexGrow: 1,
              overflowY: "auto",
              height: "100%",
              overflowX: "hidden",
            }}
          >
            <Grid
              container
              style={{
                flex: 1,
              }}
            >
              <Grid
                item
                sm={4}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ProfileUpload
                  onsetProfile={(profile) => handleProfilePicture(profile)}
                  profilePhoto={profile}
                />
              </Grid>
              <Grid item sm={8}>
                <Grid container spacing={2} padding={"16px"}>
                  <Grid item sm={6}>
                    <CustomTextfeild
                      label={t("Name")}
                      name={"productName"}
                      value={payload.productName}
                      required={true}
                      handleChange={(e) => handleChange(e)}
                      inputProps={{ maxLength: 50 }}
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <CustomTextfeild
                      label={t("Model")}
                      name={"productModel"}
                      disabled={props.location.state?.id ? true : false}
                      value={payload.productModel}
                      handleChange={(e) => handleChange(e)}
                      inputProps={{ maxLength: 100 }}
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <CustomTextfeild
                      label={t("Monthly Price")}
                      name={"monthlyPrice"}
                      value={payload.monthlyPrice}
                      required={true}
                      handleChange={(e) => handleChangeAmount(e)}
                      validation={"numeric"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton edge="end" className="PasswordIcon">
                              <AttachMoneyIcon className="dollarIcon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item sm={6}>
                    <CustomTextfeild
                      label={t("Onetime Price")}
                      name={"oneTimePrice"}
                      value={payload.oneTimePrice}
                      required={true}
                      handleChange={(e) => handleChangeAmount(e)}
                      validation={"numeric"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton edge="end" className="PasswordIcon">
                              <AttachMoneyIcon className="dollarIcon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <CustomTextfield
                      type={"text"}
                      label={t("ATYPE009")}
                      name="description"
                      value={payload.description}
                      handleChange={(e) => handleChange(e)}
                      inputProps={{ maxLength: 250 }}
                      minRows={6}
                      multiline
                    />
                  </Grid>
                  <Grid item={12}>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={productType}
                        onChange={handleRadioChange}
                      >
                        <FormControlLabel
                          value="hardWare"
                          control={<Radio />}
                          label={t("Hardware")}
                        />
                        <FormControlLabel
                          value="accessory"
                          control={<Radio />}
                          label={t("ACCESSORIES")}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              justifyContent="flex-end"
              style={{
                padding: "16px",
              }}
            >
              <Grid item>
                <CancelButtons onClick={handleCancel}>
                  <Typography variant="body1" style={{ textTransform: "none" }}>
                    {t("COMMON008")}
                  </Typography>
                </CancelButtons>
              </Grid>
              <Grid item>
                <SubmitButtons onClick={handleSubmit} type="submit">
                  <Typography variant="body1" style={{ textTransform: "none" }}>
                    {t("COMMON007")}
                  </Typography>
                </SubmitButtons>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Box>
    </>
  );
}

export default AddProduct;
